/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const AccountFeatureFlagDropdown = zod.strictObject({
    label: zod.string(),
    value: zod
        .enum([
            'ALLOW_SHAPE_EDITION',
            'ALLOW_CATCHMENT_EDITION',
            'HIDE_PERIOD_QUARTER_NAME',
            'SHOW_LINK_INSTANCE_REFERENCE',
            'SHOW_BENEFICIARY_TYPES_IN_LIST_MENU',
            'SHOW_HOME_ONLINE',
            'SHOW_DEV_FEATURES',
            'ENTITY_DUPLICATES_SOFT_DELETE',
            'SHOW_MOBILE_NO_ORGUNIT_PROJECT_FEATURE_FLAG',
        ])
        .describe(
            '\* `ALLOW_SHAPE_EDITION` - ALLOW_SHAPE_EDITION\n\* `ALLOW_CATCHMENT_EDITION` - ALLOW_CATCHMENT_EDITION\n\* `HIDE_PERIOD_QUARTER_NAME` - HIDE_PERIOD_QUARTER_NAME\n\* `SHOW_LINK_INSTANCE_REFERENCE` - SHOW_LINK_INSTANCE_REFERENCE\n\* `SHOW_BENEFICIARY_TYPES_IN_LIST_MENU` - SHOW_BENEFICIARY_TYPES_IN_LIST_MENU\n\* `SHOW_HOME_ONLINE` - SHOW_HOME_ONLINE\n\* `SHOW_DEV_FEATURES` - SHOW_DEV_FEATURES\n\* `ENTITY_DUPLICATES_SOFT_DELETE` - ENTITY_DUPLICATES_SOFT_DELETE\n\* `SHOW_MOBILE_NO_ORGUNIT_PROJECT_FEATURE_FLAG` - SHOW_MOBILE_NO_ORGUNIT_PROJECT_FEATURE_FLAG',
        ),
});

export type AccountFeatureFlagDropdown = zod.input<
    typeof AccountFeatureFlagDropdown
>;
export type AccountFeatureFlagDropdownOutput = zod.output<
    typeof AccountFeatureFlagDropdown
>;
